import { render } from "./VoteSongs.vue?vue&type=template&id=25ddee22&scoped=true"
import script from "./VoteSongs.vue?vue&type=script&lang=js"
export * from "./VoteSongs.vue?vue&type=script&lang=js"

import "./VoteSongs.vue?vue&type=style&index=0&id=25ddee22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ddee22"]])

export default __exports__